import React from 'react';
import { RadioGroup, RadioGroupItem } from '../../ui/radio-group';

const WindowLocksApprovalSection = ({ formData, handleInputChange, isDark }) => {
    if (formData.recipientSource !== 'strata' || formData.sending !== 'Minutes') {
        return null;
    }

    return (
        <div className={`border-solid border-[1px] rounded-[16px] p-[20px] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.11)] w-full max-w-[822px] flex flex-col gap-[16px] transition-colors duration-200 ${
            isDark ? 'bg-[#000000] border-[#292929]' : 'bg-white border-[#d9d9d9]'
        }`}>
            <div className={`text-[16px] font-semibold transition-colors duration-200 ${
                isDark ? 'text-white' : 'text-[#072837]'
            }`}>
                Was the Quote for Window Locks approved? <span className='text-[#FF0000]'>*</span>
            </div>
            <RadioGroup
                value={formData.windowLockApproval || ''}
                onValueChange={(value) => handleInputChange('windowLockApproval', value)}
                className="flex flex-col gap-[12px]"
            >
                <label className="flex items-center gap-[8px] cursor-pointer">
                    <RadioGroupItem 
                        value='No'
                        id='windowLockApproval-no'
                        disabled
                    />
                    <span className={`text-[16px] font-normal transition-colors duration-200 ${
                        isDark ? 'text-white' : 'text-[#072837]'
                    }`}>No</span>
                </label>

                <label className="flex items-center gap-[8px] cursor-pointer">
                    <RadioGroupItem 
                        value='Yes, Qsec'
                        id='windowLockApproval-yes-qsec'
                        disabled
                    />
                    <span className={`text-[16px] font-normal transition-colors duration-200 ${
                        isDark ? 'text-white' : 'text-[#072837]'
                    }`}>Yes, Qsec</span>
                </label>

                <label className="flex items-center gap-[8px] cursor-pointer">
                    <RadioGroupItem 
                        value='Yes (name contractor)'
                        id='windowLockApproval-yes-contractor'
                        disabled
                    />
                    <span className={`text-[16px] font-normal transition-colors duration-200 ${
                        isDark ? 'text-white' : 'text-[#072837]'
                    }`}>Yes (name contractor)</span>
                </label>
            </RadioGroup>

            {formData.windowLockApproval === 'Yes (name contractor)' && (
                <div>
                    <input
                        className={`w-full px-[16px] py-[12px] rounded-[8px] border-none text-[16px] outline-none transition-colors duration-200 ${
                            isDark 
                                ? 'bg-[#161515] text-white' 
                                : 'bg-[#f5f5f5] text-[#072837]'
                        }`}
                        type='text'
                        disabled
                        placeholder='Enter contractor name'
                        name='contractorName'
                        value={formData.contractorName}
                        onChange={(e) => handleInputChange('contractorName', e.target.value)}
                    />
                </div>
            )}
        </div>
    );
};

export default WindowLocksApprovalSection;
